// extracted by mini-css-extract-plugin
export var coral = "ProductLabel-module--coral--8AfWh";
export var darkGreen = "ProductLabel-module--darkGreen--v4aOx";
export var label = "ProductLabel-module--label--+ibWD";
export var mediumGreen = "ProductLabel-module--mediumGreen--VQtbS";
export var rose = "ProductLabel-module--rose--STeYx";
export var rounded = "ProductLabel-module--rounded--Boyfx";
export var text = "ProductLabel-module--text--O5Sp4";
export var wrapper = "ProductLabel-module--wrapper--tIRXf";